module.exports = __webpack_public_path__ + "static/media/subscriptions.f242f694.svg";